export enum CompanyType {
  /** Private company */
  PRC = 'PRC',
  /** Public company */
  PUC = 'PUC',
  /** Recognised Company */
  RCO = 'RCO',
  /** Limited Liability Partnership */
  LLP = 'LLP',
  /** Recognised Limited Liability Partnership  */
  RLP = 'RLP',
  /** Limited Partnership */
  LPA = 'LPA',
  /** Recognised Limited Partnership */
  RPA = 'RPA',
  /** General Partnership */
  GPA = 'GPA',
  /** Recognised General Partnership */
  RGP = 'RGP',
  /** Non-Profit Incorporated Organisation */
  NPI = 'NPI',
  /** Special Purpose Company  */
  SPC = 'SPC',
  /** Private Protected Cell Company */
  PRPC = 'PRPC',
  /** Public Protected Cell Company */
  PUPC = 'PUPC',
  /** Foundation */
  FOU = 'FOU',
  /** Private Investment Company */
  PRI = 'PRI',
  /** Public Investment Company */
  PUI = 'PUI',
}

export const COMPANY_TYPE_MAP: Map<string, string> = new Map([
    [CompanyType.PRC, 'Private Company'],
    [CompanyType.PUC, 'Public Company'],
    [CompanyType.SPC, 'Special Purpose Company'],
    [CompanyType.PRI, 'Private Investment Company'],
    [CompanyType.PUI, 'Public Investment Company'],
    [CompanyType.GPA, 'General Partnership'],
    [CompanyType.LLP, 'Limited Liability Partnership'],
    [CompanyType.LPA, 'Limited Partnership'],
    [CompanyType.RCO, 'Recognised Company'],
    [CompanyType.RLP, 'Recognised Limited Liability Partnership'],
    [CompanyType.RPA, 'Recognised Limited Partnership'],
    [CompanyType.RGP, 'Recognised General Partnership'],
    [CompanyType.NPI, 'Non-Profit Incorporated Organisation'],
    [CompanyType.FOU, 'Foundation'],
])